import { iconsSet } from "../../../../assets/icons/icons";
// import defaultContent from "../default";
export default {
  hero: {
    img: {
      url: "https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_investidorquant.png",
      alt: "Estratégias Golden Bull",
    },
    title: "Torne-se O Investidor Quant!",

    // String ou array de strings
    text: [
      "O Investidor Quant nasceu com o objetivo de mudar o mundo dos investimentos desenvolvendo estratégias que buscam trazer o melhor risco/retorno ao investidor.",
      "Queremos te entregar estratégias diversificadas, com risco/retorno atrativo e validação estatística. Você topa?",
    ],
    testimonial: {
      text: "Retorno se constrói com dados e risco se controla com estatística",
      author: {
        name: "Victor Lago, CEO do O Investidor Quant",
        // picture: "",
      },
    },
  },

  strategies: {
    title: "Estratégias do Investidor Quant",
    heading: "Opere sem precisar abrir o celular!",
    subtitle:
      "Todas estratégias são desenvolvidas com Data Mining aliado a testes de robustez avançados como, por exemplo, o WFA desenvolvido por Robert Pardo. E tudo isso está na palma da sua mão, basta alguns cliques para começar!",
  },

  cta: {
    title: "Vamos começar?",
    subtitle: "Ative agora mesmo a extensão e se torne O Investidor Quant.",
    buttonText: "Ativar modo Investidor Quant!",
  },

  about: {
    title: "Sobre o desenvolvedor",
    subtitle: "O Investidor Quant",
    col1: [
      "Nascemos da ideia de atender à real necessidade dos investidores: oferecer clareza sobre o que esperar nos investimentos, permitir que tenham tempo para desfrutar da vida, sem a necessidade de se dedicar excessivamente ao estudo do mercado financeiro, e proporcionar consistência independente do cenário do mercado. ",
      "Nosso diferencial está na utilização de técnicas avançadas de data mining aliadas à estatística para criar e validar algoritmos sofisticados de trade. Essa abordagem nos permite analisar grandes volumes de dados de mercado e identificar padrões significativos, o que nos ajuda a tomar decisões de investimento mais informadas e precisas. ",
    ],
    col2: [
      "Por trás de nossos algoritmos está a expertise e a experiência de mercado financeiro do nosso CEO, Victor Lago. Com anos de vivência no setor, Victor é o responsável pelo desenvolvimento e aprimoramento contínuo de nossos algoritmos, garantindo que permaneçamos na vanguarda das estratégias de investimento. ",
    ],
  },

  stats: {
    title: "Alguns números O Investidor Quant",
    subtitle: "Mais de 7 anos de experiência operando globalmente",
    data: [
      {
        value: "+7",
        description: "Anos em atividade",
      },
      {
        value: "+U$ 20M",
        description: "Movimentados no mercado por mês",
      },
      {
        value: "+10M",
        description: "De estratégias mineradas e testadas",
      },
    ],
  },

  features: {
    title: "Por que utilizar os robôs do Investidor Quant?",
    subtitle: "Veja quais as principais vantagens dos nossos robôs.",
    data: [
      {
        icon: iconsSet.calendar,
        title: "30 dias para testar",
        description:
          "Teste nossa estratégia e confira a performance em sua conta",
      },
      {
        icon: iconsSet.code,
        title: "100% automatizado",
        description:
          "Realizamos todos ajustes e parametrizações da estratégia automaticamente.",
      },
      {
        icon: iconsSet.chat,
        title: "Suporte Individual",
        description:
          "Priorizamos um atendimento individual de qualidade visando sempre esclarecer as dúvidas de nossos clientes.",
      },
      {
        icon: iconsSet.lightning,
        title: "Velocidade",
        description:
          "Os nossos algoritmos conseguem realizar cálculos após a abertura, tomando decisões mais rápido que qualquer ser humano.",
      },
      {
        icon: iconsSet.clock,
        title: "Ganhe Tempo",
        description:
          "Você não precisa ficar na frente do computador para realizar suas operações. Após sua escolha, a automação opera por você.",
      },
      {
        icon: iconsSet.favorite,
        title: "Sem Emocional",
        description:
          "Com a estratégia automatizada você vai acabar com todos seus problemas de tomar decisões impulsivas e irracionais",
      },
      // ...defaultContent.features.data,
    ],
  },

  testimonials: [
    {
      text: "O Investidor Quant trouxe clareza e consistência aos meus investimentos. As estratégias sofisticadas proporcionaram resultados surpreendentes.",
      author: "Leandro Venetillo",
      job: "Analista ESG",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/eliseu-sandres-120x120.jpg",
    },
    {
      text: "Com o Investidor Quant, encontrei o que buscava para ter mais tempo e retorno. Suas estratégias e seu suporte revolucionaram meus resultados financeiros.",
      author: "Yuri Sumar",
      job: "Militar",
      // image_url:
      //   "https://newbot.com.br/wp-content/uploads/2018/03/Victor-nardi-vilella-120x120.jpg",
    },
  ],

  plans: {
    title: "Planos",
    subtitle: "Conheça os nossos planos",
  },
};

// https://ontick-img.s3.sa-east-1.amazonaws.com/parceiros/mockup_lp_algotrading.png
